import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';

const wrapperStyle: CSSProperties = {
    position: 'fixed',
    width: '350px',
    height: '350px',
    marginTop: '-175px',
    top: '50%',
    marginLeft: '-175px',
    left: '50%',
    zIndex: 99,
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 0 5px 0',
    boxShadow: Tgcc.Styles.boxShadow,
    '@media (max-width:375px)': {
        height:'290px',
        top:'58%'
    },
    '@media (max-width:320px)': {
        height:'225px',
        top:'62%',
        left:'58%',
        width:'300px'
    }
}

const titleStyle: CSSProperties = {
    fontSize: '25px',
    letterSpacing: '5px'
}

const textStyle: CSSProperties = {
    fontSize: '15px',
    letterSpacing: '3px',
    padding: '10px',
    margin: '5px 10px',
    textAlign: 'center',
    width: '310px',
    height: '270px',
    alignSelf: 'center',
    overflowY: 'auto',
    resize: 'none',
    '@media (max-width:320px)': {
        width:'300px'
    }
}

const backStyle: CSSProperties = {
    backgroundColor: Tgcc.Styles.buttonBackground,
    fontFamily: 'CenturyGothic',
    fontSize: '12px',
    fontTransform: 'uppercase',
    textAlign: 'center',
    width: '70px',
    border: '1px solid transparent',
    boderSpacing: 0,
    cursor: 'pointer',
    marginLeft:'10px'
}

const addStyle: CSSProperties = {
    backgroundColor: Tgcc.Styles.buttonBackground,
    fontFamily: 'CenturyGothic',
    fontSize: '12px',
    fontTransform: 'uppercase',
    textAlign: 'center',
    width: '210px',
    border: '1px solid transparent',
    boderSpacing: 0,
    cursor: 'pointer',
    marginRight:'10px'
}

const footerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'none',
    justifyContent: 'space-between',
    width: '100%',
    padding: '2px 20px 0 20px'
}

class Props extends Tgcc.BaseProps{
    visible: boolean;
    editState: Tgcc.EditStates;
    text: string;
    title: string;
    addToProof: (text:string) => void;
    fontFamily?:string;
    btnColor?:string;
}


class _TextEditPopup extends React.Component<Props, any>{
    state: any = {
        text: null
    };

    componentWillMount(){
        this.setState({text: this.props.text});
        textStyle.fontFamily = this.props.fontFamily

        if(this.props.fontFamily){
            textStyle.fontFamily = this.props.fontFamily;
            titleStyle.fontFamily = this.props.fontFamily;
            backStyle.fontFamily = this.props.fontFamily;
            addStyle.fontFamily = this.props.fontFamily;
        }
        if(this.props.btnColor){
            backStyle.backgroundColor = this.props.btnColor;
            addStyle.backgroundColor = this.props.btnColor;
        }
    }
    componentWillReceiveProps(newProps: any){
        this.setState({text: newProps['text']});
    }
    backToProof = () => {
        this.props.dispatch( { type: Tgcc.StateAction.SetEditState, payload: null})
    }

    addToProof = () => {
        this.props.addToProof(this.state.text);
    }

    handleTextChange = (evt) => {
        this.setState({text: evt.target.value});
    }

    render() {
        if(!this.props.visible){
            document.body.style.overflow = 'auto'; // re-enable scrolling on body
            return ( <a/> )
        }

        document.body.style.overflow = 'hidden'; // disable scrolling on body
        return (
            <div style={wrapperStyle}>
                <div style={titleStyle}>{this.props.title}</div>
                <textarea autoFocus style={textStyle} onChange={this.handleTextChange} value={this.state.text} />
                <div style={footerStyle}>
                    <div className="hoverBorder" style={backStyle} onClick={this.backToProof}>Back</div>
                    <div className="hoverBorder" style={addStyle} onClick={this.addToProof}>Add</div>
                </div>
            </div>
        )
    }


}


const mapStateToProps = (state : Tgcc.GlobalState, myProps: any) => {
    return { 
        visible: state.EditState == myProps.editState
    }
};
export var TextEditPopup = connect(mapStateToProps)(Radium(_TextEditPopup));